import { useHistory, useLocation } from "react-router-dom";

const useSearchTerm = () => {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const searchTerm = params.get("search") || "";

  const setSearchTerm = (value) => {
    const newParams = new URLSearchParams(location.search);

    if (value) {
      newParams.set("search", value);
    } else {
      newParams.delete("search");
    }

    history.replace({
      pathname: location.pathname,
      search: newParams.toString() ? `?${newParams.toString()}` : "",
    });
  };

  return [searchTerm, setSearchTerm];
};

export default useSearchTerm;
